import { DateTime } from 'luxon';
import { Trip, TripStopRecord } from '../types';

// A stop counts toward on-time stats only when it has both an appointment and
// an actual arrival. It is on time when it arrived within the grace window;
// lateness itself is reported without the grace subtracted.
export const ON_TIME_GRACE_MINUTES = 15;

export function stopLatenessHours(stop: TripStopRecord): number | null {
  if (!stop.appointmentAt || !stop.actualArrival) {
    return null;
  }
  const late = DateTime.fromISO(stop.actualArrival).diff(
    DateTime.fromISO(stop.appointmentAt),
    'hours'
  ).hours;
  return Math.max(0, late);
}

export function stopIsOnTime(stop: TripStopRecord): boolean | null {
  const lateness = stopLatenessHours(stop);
  if (lateness === null) {
    return null;
  }
  return lateness <= ON_TIME_GRACE_MINUTES / 60;
}

export type TripStats = {
  appointmentStops: number;
  onTimeStops: number;
  worstLatenessHours: number | null;
};

export function tripStats(trip: Trip): TripStats {
  let appointmentStops = 0;
  let onTimeStops = 0;
  let worstLatenessHours: number | null = null;
  trip.stops.forEach((stop) => {
    const onTime = stopIsOnTime(stop);
    if (onTime === null) {
      return;
    }
    appointmentStops += 1;
    if (onTime) {
      onTimeStops += 1;
    }
    const lateness = stopLatenessHours(stop)!;
    if (worstLatenessHours === null || lateness > worstLatenessHours) {
      worstLatenessHours = lateness;
    }
  });
  return { appointmentStops, onTimeStops, worstLatenessHours };
}

export function tripDurationHours(trip: Trip): number | null {
  const endedAt = trip.finishedAt || trip.abandonedAt;
  if (!trip.startedAt || !endedAt) {
    return null;
  }
  return DateTime.fromISO(endedAt).diff(DateTime.fromISO(trip.startedAt), 'hours').hours;
}

